import { BRAND_TITLE } from "./config";
import { getPath } from "./router";

const DEFAULT_DESC =
  "尚诺艾 — 古典名曲与名画的策展式线上空间：名曲馆、名画馆、对对配馆、测歌名与小程序联动。";

function ensureMetaDescription(content: string): void {
  let el = document.querySelector('meta[name="description"]');
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", "description");
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** 根据当前 path + query 设置基础标题（不含异步拉取的曲名/画名） */
export function applyRouteMeta(): void {
  const path = getPath();
  const sp = new URLSearchParams(window.location.search);

  let title = `古典音乐与名画 · ${BRAND_TITLE}`;
  let desc = DEFAULT_DESC;

  switch (path) {
    case "/music": {
      const tid = sp.get("track");
      title = tid ? `名曲详情 · ${BRAND_TITLE}` : `名曲馆 · ${BRAND_TITLE}`;
      desc = tid
        ? "尚诺艾名曲馆：单曲介绍与站内试听。"
        : "尚诺艾名曲馆：首批曲目内置音频，按时期浏览。";
      break;
    }
    case "/art": {
      const pid = sp.get("painting");
      title = pid ? `名画详情 · ${BRAND_TITLE}` : `名画馆 · ${BRAND_TITLE}`;
      desc = pid
        ? "尚诺艾名画馆：虚拟馆藏与作品简介。"
        : "尚诺艾名画馆：虚拟馆藏，古典名画高清浏览。";
      break;
    }
    case "/pair":
      title = `对对配馆 · ${BRAND_TITLE}`;
      desc = "尚诺艾对对配馆：以名画为主，按艺术时期策展相配古典名曲。";
      break;
    case "/guides": {
      const lid = sp.get("lecture");
      title = lid ? `导读详情 · ${BRAND_TITLE}` : `音乐家导读 · ${BRAND_TITLE}`;
      desc = "尚诺艾音乐家导读：一对音乐家的短传记与站内可听名曲。";
      break;
    }
    case "/games":
      title = `互动游戏 · ${BRAND_TITLE}`;
      desc = "古典音乐测歌名、古典名画对对配、古典音乐线条等互动游戏；部分玩法请在微信中打开对应小程序。";
      break;
    case "/visualizer":
      title = `粒子特效 · ${BRAND_TITLE}`;
      desc = "尚诺艾粒子特效：跟随音乐的实时 3D 管弦粒子可视化。";
      break;
    case "/about":
      title = `关于 · ${BRAND_TITLE}`;
      desc = "关于尚诺艾与古典音乐、名画数字体验。";
      break;
    case "/":
    default:
      title = `首页 · ${BRAND_TITLE}`;
      desc = DEFAULT_DESC;
  }

  document.title = title;
  ensureMetaDescription(desc);
}

export function setDetailTitle(segment: string): void {
  document.title = `${segment} · ${BRAND_TITLE}`;
}
